(function () {
  class CompleteTheLook extends HTMLElement {
    constructor() {
      super();
      this.miniCart = document.querySelector('mini-cart');
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.querySelectorAll('[data-complete-the-look-item]').forEach((item) => this.initItem(item));

      if (typeof subscribe === 'function') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          this.syncWithCart();
        });
      }

      this.onCartUpdated = () => this.syncWithCart();
      document.addEventListener('cart:updated', this.onCartUpdated);

      this.syncWithCart();
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }

      if (this.onCartUpdated) {
        document.removeEventListener('cart:updated', this.onCartUpdated);
      }
    }

    initItem(item) {
      const variantsScript = item.querySelector('[data-complete-the-look-variants]');
      const mediaScript = item.querySelector('[data-complete-the-look-media]');
      const addButton = item.querySelector('[data-complete-the-look-add]');
      const optionSelects = item.querySelectorAll('[data-complete-the-look-option]');

      if (!variantsScript || !addButton) return;

      try {
        item.variants = JSON.parse(variantsScript.textContent || '[]');
      } catch (e) {
        item.variants = [];
      }

      try {
        item.mediaMap = JSON.parse(mediaScript?.textContent || '[]').reduce((map, entry) => {
          map[entry.id] = entry.featured_image;
          return map;
        }, {});
      } catch (e) {
        item.mediaMap = {};
      }

      item.selectedOptions = {};
      optionSelects.forEach((select) => {
        const group = select.closest('[data-complete-the-look-option-group]');
        const optionIndex = parseInt(group?.dataset.optionIndex, 10);
        if (Number.isNaN(optionIndex)) return;

        item.selectedOptions[optionIndex] = select.value;
        select.addEventListener('change', () => {
          item.selectedOptions[optionIndex] = select.value;
          this.updateItemVariant(item);
        });
      });

      this.updateItemVariant(item);

      addButton.addEventListener('click', () => this.addToCart(item, addButton));
    }

    getMatchedVariant(item) {
      const optionCount = Object.keys(item.selectedOptions).length;

      if (optionCount === 0) {
        return item.variants.find((variant) => variant.available) || item.variants[0] || null;
      }

      return (
        item.variants.find((variant) => {
          return variant.options.every((value, index) => item.selectedOptions[index] === value);
        }) || null
      );
    }

    updateItemVariant(item) {
      const addButton = item.querySelector('[data-complete-the-look-add]');
      const priceEl = item.querySelector('[data-complete-the-look-price]');
      const imageEl = item.querySelector('[data-complete-the-look-image]');
      const wishlistBtn = item.querySelector('.complete-the-look__wishlist');
      const optionSelects = item.querySelectorAll('[data-complete-the-look-option]');
      const matchedVariant = this.getMatchedVariant(item);

      optionSelects.forEach((select) => {
        const group = select.closest('[data-complete-the-look-option-group]');
        const optionIndex = parseInt(group?.dataset.optionIndex, 10);
        if (Number.isNaN(optionIndex)) return;

        Array.from(select.options).forEach((option) => {
          const value = option.value;
          const isAvailable = item.variants.some((variant) => {
            if (variant.options[optionIndex] !== value) return false;
            return variant.options.every((variantValue, index) => {
              if (index === optionIndex) return true;
              if (item.selectedOptions[index] === undefined) return true;
              return variantValue === item.selectedOptions[index];
            }) && variant.available;
          });

          option.disabled = !isAvailable;
        });
      });

      if (!matchedVariant) {
        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');
        addButton.dataset.variantId = '';
        return;
      }

      addButton.dataset.variantId = matchedVariant.id;

      if (wishlistBtn) {
        wishlistBtn.dataset.variantId = matchedVariant.id;
      }

      if (priceEl) {
        this.updatePrice(priceEl, matchedVariant);
      }

      if (imageEl && item.mediaMap[matchedVariant.id]) {
        imageEl.src = item.mediaMap[matchedVariant.id];
      }

      if (matchedVariant.available) {
        addButton.disabled = false;
        addButton.removeAttribute('aria-disabled');
        if (!addButton.classList.contains('loading')) {
          addButton.textContent = addButton.dataset.defaultLabel || 'Add to bag';
        }
      } else {
        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');
        addButton.textContent = window.theme?.strings?.soldOut || 'Sold out';
      }
    }

    updatePrice(priceEl, variant) {
      const price = priceEl.querySelector('.price');
      const priceRegular = priceEl.querySelector('.price__regular .price-item--regular');
      const priceSaleItem = priceEl.querySelector('.price__sale .price-item--sale');
      const priceCompareItem = priceEl.querySelector('.price__sale .price-item--regular');

      if (!price || !priceRegular) return;

      const formatMoney = (cents) => {
        if (window.theme?.Currency?.formatMoney && window.theme?.shopSettings?.moneyFormat) {
          return window.theme.Currency.formatMoney(cents, window.theme.shopSettings.moneyFormat);
        }

        if (window.Shopify?.formatMoney) {
          return window.Shopify.formatMoney(cents, window.theme?.moneyFormat);
        }

        return (cents / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD',
        });
      };

      const moneyHtml = (cents) =>
        `<price-money><bdi>${formatMoney(cents)}</bdi></price-money>`;

      priceRegular.innerHTML = moneyHtml(variant.price);

      if (priceSaleItem) {
        priceSaleItem.innerHTML = moneyHtml(variant.price);
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        price.classList.add('price--on-sale');
        price.classList.remove('price--sold-out');
        if (priceCompareItem) {
          priceCompareItem.innerHTML = moneyHtml(variant.compare_at_price);
        }
      } else {
        price.classList.remove('price--on-sale');
        if (variant.available) {
          price.classList.remove('price--sold-out');
        } else {
          price.classList.add('price--sold-out');
        }
      }
    }

    addToCart(item, button) {
      const variantId = button.dataset.variantId;
      if (!variantId || button.classList.contains('loading')) return;

      if (document.body.classList.contains('template-cart') || !window.theme?.shopSettings?.cartDrawer) {
        window.Shopify?.postLink(window.theme.routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1,
          },
        });
        this.hideItem(item);
        return;
      }

      if (!button.dataset.defaultLabel) {
        button.dataset.defaultLabel = button.textContent.trim();
      }

      button.disabled = true;
      button.classList.add('loading');

      const sections = this.miniCart
        ? this.miniCart.getSectionsToRender().map((section) => section.id)
        : [];

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections,
        sections_url: window.location.pathname,
      });

      fetch(`${window.theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status) {
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'complete-the-look',
                productVariantId: variantId,
                errors: parsedState.errors || parsedState.description,
                message: parsedState.message,
              });
            }

            document.dispatchEvent(
              new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description,
                },
              })
            );
            return;
          }

          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'complete-the-look',
              productVariantId: variantId,
            });
          }

          if (this.miniCart) {
            this.miniCart.renderContents(parsedState);
          }

          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: {
                product: parsedState,
              },
            })
          );

          this.hideItem(item);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          button.classList.remove('loading');
          if (button.isConnected) {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
          }
        });
    }

    hideItem(item, animate = true) {
      if (item.classList.contains('complete-the-look__item--hidden')) return;

      if (animate) {
        item.classList.add('complete-the-look__item--removing');

        window.setTimeout(() => {
          item.classList.remove('complete-the-look__item--removing');
          item.classList.add('complete-the-look__item--hidden');
          this.checkEmpty();
        }, 250);
        return;
      }

      item.classList.add('complete-the-look__item--hidden');
      this.checkEmpty();
    }

    showItem(item) {
      item.classList.remove('complete-the-look__item--hidden', 'complete-the-look__item--removing');
      this.classList.remove('complete-the-look--hidden');
    }

    checkEmpty() {
      const visibleItems = this.querySelectorAll(
        '[data-complete-the-look-item]:not(.complete-the-look__item--hidden)'
      );

      if (visibleItems.length === 0) {
        this.classList.add('complete-the-look--hidden');
      } else {
        this.classList.remove('complete-the-look--hidden');
      }
    }

    syncWithCart() {
      if (!window.theme?.routes?.cart_url) return;

      fetch(`${window.theme.routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cart) => {
          const productIdsInCart = new Set(cart.items.map((lineItem) => lineItem.product_id));

          this.querySelectorAll('[data-complete-the-look-item]').forEach((item) => {
            const productId = parseInt(item.dataset.productId, 10);

            if (productIdsInCart.has(productId)) {
              this.hideItem(item, false);
            } else {
              this.showItem(item);
            }
          });

          this.checkEmpty();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('complete-the-look', CompleteTheLook);
})();
